import {
	NOTIF_WS_CONNECTING,
	NOTIF_WS_CONNECTED,
	NOTIF_WS_DISCONNECTED,
	NOTIF_SET_ITEMS,
	NOTIF_RECEIVED,
	NOTIF_MARK_ALL_READ,
} from "../actions/notificationActions"

const initialState = {
	connected: false,
	connecting: false,
	items: [],
	unread: 0,
	lastClose: null, // { code, reason } de la dernière coupure WS (diagnostic)
}

const countUnread = (items, lastSeenId) =>
	items.filter((it) => it.id > lastSeenId).length

export default function notificationReducer(state = initialState, action) {
	switch (action.type) {
		case NOTIF_WS_CONNECTING:
			return { ...state, connecting: true }
		case NOTIF_WS_CONNECTED:
			return { ...state, connected: true, connecting: false, lastClose: null }
		case NOTIF_WS_DISCONNECTED:
			return {
				...state,
				connected: false,
				connecting: false,
				// Sans payload (stop volontaire), on garde le dernier code connu.
				lastClose: action.payload ?? state.lastClose,
			}
		case NOTIF_SET_ITEMS: {
			const { items, lastSeenId } = action.payload
			return { ...state, items, unread: countUnread(items, lastSeenId) }
		}
		case NOTIF_RECEIVED: {
			// Évite les doublons (ré-émission / chevauchement avec le rattrapage).
			const exists = state.items.some((it) => it.id === action.payload.id)
			if (exists) return state
			return {
				...state,
				items: [action.payload, ...state.items],
				unread: state.unread + 1,
			}
		}
		case NOTIF_MARK_ALL_READ:
			return { ...state, unread: 0 }
		default:
			return state
	}
}
